@if(isLoading$ | async) {
    <div class="overlay">
        <div>
            <app-spinner [trigger]="TRUE" [message]="message()"></app-spinner>
        </div>  
    </div>
}
